import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './LoveReasonGenerator.css';

const reasons = [
    "You light up my world like no one else. ✨",
    "Your smile is my favorite sight. 😊",
    "I love your kindness and your big heart. ❤️",
    "You make even ordinary days feel magical. 🌈",
    "Being with you feels like home. 🏡",
    "Your laughter is my favorite melody. 🎶",
    "You inspire me to be a better person every day. 🌟",
    "I love the way you understand me without words. 🤗",
    "Your presence is the best gift I could ever ask for. 🎁",
    "You are my forever and always. 💖",
    "Your eyes tell the story of a beautiful soul. 👁️✨",
    "With you, every moment feels like a dream. 🌙",
    "You’re my safe haven in a chaotic world. 🛡️",
    "Your courage motivates me to face my fears. 💪",
    "You make my heart race in the best way. 💓",
    "You accept me for who I truly am. 🙌",
    "Your voice soothes me like no other. 🎵",
    "Every day with you is a new adventure. 🚀",
    "You bring out the best in me. 🌼",
    "I’m grateful for your endless support. 🤝",
    "Your love feels like warm sunshine on a cold day. ☀️",
    "You make ordinary moments extraordinary. ✨",
    "I love your beautiful soul shining through. 🌟",
    "You’ve taught me the true meaning of love. ❤️",
    "You’re my partner in crime and my best friend. 👫",
    "I adore the way you laugh at my silly jokes. 😂",
    "Your hugs are my favorite place to be. 🤗",
    "You make me feel special every single day. 💫",
    "I love how you care so deeply for others. 🌷",
    "Your strength inspires me in so many ways. 💥",
    "I admire your passion and dedication. 🔥",
    "You make me believe in miracles. 🌠",
    "Your love is my anchor and my wings. ⚓🕊️",
    "I love how you always know what to say. 💬",
    "You bring peace to my restless heart. 🕊️",
    "Your smile is contagious and lights up my day. 😄",
    "I love dreaming about our future together. 🌅",
    "You make every day worth waking up for. ☀️",
    "Your kindness has no limits. 🌈",
    "I’m thankful for every moment with you. 🙏",
    "You complete me in ways I never imagined. 💞",
    "You’re my sunshine after the storm. 🌤️",
    "Your love is my greatest treasure. 💎",
    "I love the way you see beauty in the little things. 🌸",
    "You make my world feel whole. 🌍",
    "I love growing with you every day. 🌱",
    "You’re the reason my heart sings. 🎶",
    "You fill my life with endless joy. 🎉",
    "I love you more than words can express. 💖",
    "You’re my forever and my always. 🔒",
    "I can’t wait to make more memories with you. 📸",
    "Your love is the light that guides me home. 🕯️",
  ];

  const generateHearts = (count = 15) => {
    const hearts = [];
    for (let i = 0; i < count; i++) {
      const style = {
        left: `${Math.random() * 100}%`,
        animationDuration: `${5 + Math.random() * 5}s`,
        animationDelay: `${Math.random() * 5}s`,
        width: `${15 + Math.random() * 15}px`,
        height: `${15 + Math.random() * 15}px`,
        opacity: 0.7 + Math.random() * 0.3,
      };
      hearts.push(<div key={i} className="heart" style={style}></div>);
    }
    return hearts;
  }; 
  

export default function LoveReasonGenerator() {
  const [reason, setReason] = useState("");
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    setHearts(generateHearts(20));
  }, []);

  const generateReason = () => {
    const randomIndex = Math.floor(Math.random() * reasons.length);
    setReason(reasons[randomIndex]);
  };

  return (
    <motion.div
      className="love-generator-container"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="floating-hearts">{hearts}</div>  
      <h2>Why I Love You 💌</h2>
      <motion.button
        onClick={generateReason}
        whileHover={{ scale: 1.07, backgroundColor: '#e91e63', color: '#fff' }}
        whileTap={{ scale: 0.95 }}
        className="generate-btn"
        type="button"
      >
        Generate a Reason
      </motion.button>

      {reason && (
        <motion.div
          className="reason-message"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <p>{reason}</p>
        </motion.div>
      )}
    </motion.div>
  );
}
